import React, { FC, useContext } from 'react';

import BasicText from '@ui/atoms/BasicText';
import Button from '@ui/atoms/Button';
import FlexColumn from '@ui/atoms/FlexColumn';
import NavigationSection from '@ui/atoms/NavigationSection';
import SubheadingText from '@ui/atoms/SubheadingText';

import CenteredGridItem from '@ui/molecules/CenteredGridItem';

import fullWidth from '@ui/styled/FullWidth';
import spaced from '@ui/styled/Spaced';

import FlowContext from '@providers/FlowContextProvider';

import { IFlowStepProps } from '@folx-types/flow-steps';

export interface IMedicareIneligibilityStepContent {
	title: string;
	description: string;
}

export interface IMedicareIneligibilityStepProps extends IFlowStepProps {
	pageContent: IMedicareIneligibilityStepContent;
}

const SpacedColumn = spaced(FlexColumn);
const FullWidthButton = fullWidth(Button);

const MedicareIneligibilityStep: FC<IMedicareIneligibilityStepProps> = ({
	pageContent,
	stepKey,
}) => {
	const context = useContext(FlowContext);
	const { handleNavBack, handleNavNext } = context;

	const navigateNext = () => handleNavNext(stepKey);
	const navigateBack = () => handleNavBack(stepKey);

	const { title, description } = pageContent;
	return (
		<CenteredGridItem>
			<SpacedColumn gap="sm" marginBottom="xl">
				<SubheadingText>{title}</SubheadingText>
				<BasicText>{description}</BasicText>
			</SpacedColumn>
			<NavigationSection>
				<FullWidthButton label="Back" labelSize="md" onClick={navigateBack} />
				<FullWidthButton label="Next" labelSize="md" variant="secondary" onClick={navigateNext} />
			</NavigationSection>
		</CenteredGridItem>
	);
};

export default MedicareIneligibilityStep;
